import Vue from 'vue'
const urls = {
    centerDevUrl: '',
    centerProUrl: ''
 }
 const nodeEnv = process.env.mode;
 export default {
     getBaseUrl(){
         if(nodeEnv === 'production'){
             return urls.centerProUrl;
         }else{
             return urls.centerDevUrl;
         }
     }
 }
if(nodeEnv === 'production'){
   // 正式-真信网络公众号 wx8b9d724bdd9eb38d，测试 wxffb481a62616661d
  // appKey : "25wehl3u27niw", // "qd46yzrfq3c5f", 正式   "25wehl3u27niw", 测试  融云的聊天 appKey
  Vue.prototype.configData = {
    AppID: 'wx8b9d724bdd9eb38d',
    appKey : "qd46yzrfq3c5f",
    callbackURL: '/store'
  }
}else{
  Vue.prototype.configData = {
    AppID: 'wxffb481a62616661d',
    appKey : "25wehl3u27niw",
    callbackURL: ''
    // AppID: 'wx8b9d724bdd9eb38d',
    // appKey : "qd46yzrfq3c5f",
  }
}



// WEBPACK FOOTER //
// ./src/config/urls.js